import { ReactNode } from "react"
import { Table as Tab } from "flowbite-react"
import cn from "classnames"

interface ITableHead {
  children: ReactNode
  className?: string
}

const TableHead = ({ children, className }: ITableHead) => {
  return <Tab.Head className={cn("divide-x divide-y border-2", className)}>{children}</Tab.Head>
}

export default TableHead
